import React, {useState} from 'react';
import styles from './OpenMultiLanguage.module.css';
import Input from '../Input';
import Button from "../Button";
import {Language} from "../../types/PluginData";
import {useTranslation} from "react-i18next";
import Heading from "../Heading";

type OpenMultiLanguageProps = {
    onSubmit: (value: string) => void;
    languages: Language[];
    defaultValues: object;
};

const OpenMultiLanguage: React.FC<OpenMultiLanguageProps> = ({ onSubmit, languages, defaultValues }) => {
    const [values, setValues] = useState<Map<string,string>>(new Map<string,string>(Object.entries(defaultValues)));
    const { t } = useTranslation(['common'])

    const handleChange = (property: string, newValue: any) => {
    setValues(new Map(values.set(property, newValue)));
    };

    const handleSubmit = () => {
        onSubmit(JSON.stringify(Object.fromEntries(values.entries())));
    };

    return (
        <div className={styles.modalContentWrapper}>
            {languages.map((lang) => {return(
                <Input
                    type="text"
                    placeholder= {lang.jtl}
                    property= {lang.jtl}
                    value={values.get(lang.jtl) ?? ""}
                    onChange={handleChange}
                />
            )})}
            <Button hierarchy={"primary"} text={t("add")} fn={handleSubmit} classes={"w-100"}/>
        </div>
    );
};

export default OpenMultiLanguage;
